import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import SelectFirm from "../SelectFirm/SelectFirm";

const FirmInfo = ({data, handleChangeInput, viewMode, deleted, handleChangeDropdown}) => {
    return (
        <div className="Firm-info">
            <div className="Firm-info_column">
                <Input
                    className="Firm-info_column_item"
                    required
                    valueType="text"
                    name="name"
                    label="NAME"
                    value={data.name}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Firm-info_column_item"
                    valueType="text"
                    name="address"
                    label="ADDRESS"
                    value={data.address}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Firm-info_column_item"
                    valueType="text"
                    name="city"
                    label="CITY"
                    value={data.city}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Firm-info_column_item"
                    data={data}
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    value={data.state}
                    valueKey="state"
                    label="State"
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            </div>
            <div className="Firm-info_column">
                <Input
                    className="Firm-info_column_item"
                    valueType="text"
                    name="zip"
                    label="ZIP"
                    value={data.zip}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Firm-info_column_item"
                    valueType="phone"
                    name="phone"
                    label="PHONE"
                    value={data.phone}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <SelectFirm
                    className="Firm-info_column_item"
                    value={data.parent_firm}
                    firmName={data.name}
                    valueKey="parent_firm"
                    label="PARENT COMPANY"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input className="Firm-info_column_item"
                       valueType='text'
                       name='website'
                       label='WEBSITE'
                       value={data.website}
                       handleParentChange={handleChangeInput}
                       viewMode={viewMode}
                       deleted={deleted}
                />
            </div>
        </div>
    );
};

export default FirmInfo;
